import React from 'react'
import './style/BackDrop.css'

function BackDrop({ backDrop, fn }) {
    return (
        <div className="backDrop" onClick={fn} style={{ display: backDrop }}>
            
        </div>
    )
}

export default BackDrop
